import React from "react";
import { Button } from "devextreme-react";
import "./SaveNewHeader.scss";
import { useNavigate } from "react-router-dom";

export default function AddNewSubHeader({
  titleName,
  iconClass,
  handleCancel,
  handleSaveDetails,
  cancelText,
  saveText
}) {
  const navigate = useNavigate();

  const handleTitleClick = () => {
    navigate(-1); // go to previous page
  };
  return (

    <div className="wholePage">
      <div className="headerComponent">
        <div className="headerContainer1">
          <div className="sub-head-title" onClick={handleTitleClick}>
            <span className="icon-size">
              <i className={iconClass}></i>
            </span>
            <p>{titleName}</p>
          </div>
        </div>
        <div className="headerContainer2">
          <Button
            text={cancelText}
            height={"40px"}
            onClick={handleCancel}
            stylingMode="outlined"
            type="normal"
          />
          <Button
            text={saveText}
            stylingMode="contained"
            type="default"
            onClick={handleSaveDetails}
          />
        </div>
      </div>
    </div>
  );
}
